import { useHistory } from "react-router-dom";
import { useRecoilState } from "recoil";
import { myTimeApproveRequestsPageRoutePath } from "my-time/configs/routes";
import { useMyTimeRequestCount } from "my-time/hooks";
import { useOcIsMobile } from "oc/hooks";
import { ocNarrowMenuState } from "states";

export const useMyTimeAppbarBadge = (): {
  handleClick: () => void;
  count: number;
} => {
  const history = useHistory();
  const isMobile = useOcIsMobile();
  const { data } = useMyTimeRequestCount();
  const [narrowMenuOpened, setNarrowMenuOpened] =
    useRecoilState(ocNarrowMenuState);

  const count = data ?? 0;

  const handleClick = () => {
    if (isMobile) {
      setNarrowMenuOpened(!narrowMenuOpened);
    }
    history.push(myTimeApproveRequestsPageRoutePath);
  };

  return {
    handleClick,
    count,
  };
};
